export default __webpack_public_path__ + "static/media/netflix.e497050e.png";